import { render, staticRenderFns } from "./RelyToShainDetails.vue?vue&type=template&id=3cd929f8"
import script from "./RelyToShainDetails.vue?vue&type=script&lang=js"
export * from "./RelyToShainDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports